module.exports = __webpack_public_path__ + "assets/img/WechatIMG660.9e6e19cf.png";